import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.includeHeaders ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "required pl-0"
  }, [_c('br'), _vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectAndOrder')) + "\n      ")]), _c(VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c(VAutocomplete, {
          attrs: {
            "items": _vm.staticHeaders,
            "item-text": item => _vm.getHeaderOptionString(item),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "disabled": _vm.readonly,
            "hide-details": "",
            "multiple": "",
            "return-object": "",
            "small-chips": ""
          },
          model: {
            value: _vm.headers,
            callback: function ($$v) {
              _vm.headers = $$v;
            },
            expression: "headers"
          }
        })], 1)];
      }
    }], null, false, 2308346482)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectColumns')))])]), _c('p', {
    staticClass: "required pl-0"
  }, [_c('br'), _vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.renameColumns')) + "\n      ")])], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    staticClass: "pl-4 pr-0 d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    staticClass: "switch-dense",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.includeHeaders'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "inset": "",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.includeHeaders,
      callback: function ($$v) {
        _vm.includeHeaders = $$v;
      },
      expression: "includeHeaders"
    }
  })], 1)], 1), _vm.includeHeaders ? _c(VRow, [_c(VCol, [_c(VDataTable, {
    class: `mt-2 mb-2 states-table ${_vm.themeMode}`,
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.headers,
      "item-key": "id",
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          key: `state-row-${props.item.name}`
        }, [_c('td', {
          class: `text-center ${_vm.readonly ? '' : 'handle'}`
        }, [_c(VIcon, {
          style: `opacity: ${_vm.readonly ? 0.5 : 1}`,
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-arrows")])], 1), _c('td', [_vm._v("\n              " + _vm._s(props.index + 1) + "\n            ")]), _c('td', {
          staticClass: "text-left state-value-item"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")]), _c('td', [_c(VTextField, {
          staticStyle: {
            "padding-top": "28px"
          },
          attrs: {
            "type": "text",
            "disabled": _vm.readonly,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": _vm.mapValuesRules,
            "dense": ""
          },
          model: {
            value: props.item.mappedValue,
            callback: function ($$v) {
              _vm.$set(props.item, "mappedValue", $$v);
            },
            expression: "props.item.mappedValue"
          }
        })], 1)])];
      }
    }], null, false, 1163129317)
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };